import { render, staticRenderFns } from "./AutoCalculator.vue?vue&type=template&id=365f4024&scoped=true&"
import script from "./AutoCalculator.vue?vue&type=script&lang=js&"
export * from "./AutoCalculator.vue?vue&type=script&lang=js&"
import style0 from "./AutoCalculator.vue?vue&type=style&index=0&id=365f4024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365f4024",
  null
  
)

export default component.exports